import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';

@Injectable({
  providedIn: 'root'
})
export class UserTasklistService {

  constructor(private apiBaseService: ApiBaseService) { }

  async getUserTasklist(payload: any): Promise<any> {
    return this.apiBaseService.httpRequest('UserTasklistService/GetUserTasklist', payload, true, true);
  }
}
